module.exports = __webpack_public_path__ + "static/media/vivekaTwitter-600x314.d3ff28fe.jpg";